import { Cardinality } from "@/generated/graphql";

export interface QTIPrompt {
  responseId: string;
  contents: QTIMaterial[];
}

export interface QTIQuestion {
  responses: QTIResponse[];
  metadata: QTIMetadata;
  contents: QTIMaterial[];
  prompts?: QTIPrompt[];
  promptImage?: QTIPromptImage;
  outcomes: QTIOutcomes;
  respConditions: QTIResponseCondition[];
  feedbacks: QTIFeedback[];
}

export interface QTIPromptImage {
  attributes: Record<string, string | null | undefined>;
  content?: string;
}

export enum QTIFeedbackType {
  inline = "inline",
  modal = "modal",
  block = "block",
}

export enum QTIFeedbackShowHide {
  show = "show",
  hide = "hide",
}

export interface QTIFeedback {
  id: string;
  contents: QTIMaterial[];
  type?: QTIFeedbackType;
  showHide?: QTIFeedbackShowHide;
  outcomeId?: string;
}

export interface QTIResponseConditionVar {
  name: string;
  value?: string;
  action?: string;
  actionType?: string;
  actionIdentifier?: string;
}

export interface QTIResponseCondition {
  id?: string;
  vars: QTIResponseConditionVar[];
  conditions?: ConditionVar[];
}

export interface ConditionVar {
  conditions?: ConditionVar[];
  operation?: string;
  condition?: Condition;
}

export interface Condition {
  comparator?: string;
  id: string;
  value?: string;
  valueType?: string;
}

export type QTIOutcomes = Record<string, QTIOutcome>;

export interface QTIOutcome {
  min?: number;
  max?: number;
  cut?: number;
  default?: QTIOutcomeValue;
  type: string;
  cardinality?: Cardinality;
}

export type QTIOutcomeValue = number | string | Array<string | number>;

export type QTIMetadata = Record<string, unknown>;

export interface QTIResponseMapEntry {
  key: string;
  value: string;
}

export interface QTIResponseMapping {
  default?: string;
  lower?: string;
  upper?: string;
  entries: QTIResponseMapEntry[];
}

export interface QTICorrectArea {
  identifier: string;
  shape: string;
  coords: number[];
}

export interface QTIResponse {
  id: string;
  cardinality: Cardinality;
  type?: string;
  choiceResponse?: QTIChoiceResponse;
  correctResponses?: string[];
  correctAreas?: QTICorrectArea[];
  mapping?: QTIResponseMapping;
  wordLimit?: number;
  interactionType?: string;
}

export interface QTIChoiceResponse {
  contents?: QTIMaterial[];
  choices: QTIResponseContent[];
  shuffle: boolean;
  maxChoices?: number;
}

export interface QTIResponseContent {
  id: string;
  contents: QTIMaterial[];
  shape?: string;
  coords?: number[];
}

export interface QTIMaterial {
  type: string;
  textType?: string;
  text?: string;
}

export interface QTIResource {
  path: string;
  filename: string;
}
